import React from 'react';
import Link from 'next/link';

export const ArchivePostSection = ({ posts }) => (
    <div className='blog--bloglist'>
        <div className='blog--bloglist-wrapper'>

            <h3 className='blog--bloglist-title'>Muzology Blog Posts</h3>

            <div className='blog--bloglist-posts-section'>
                {posts.map((post, index) => (
                    <Link key={index} href={'/blog/' + post.slug}>
                        <div
                            className={`blog--bloglist-post ${index % 2 === 1 ? 'reverse-order' : ''}`}
                        >
                            <div className='blog--bloglist-post-wrapper'>
                                {post?.featuredImage && <div className='blog--bloglist-post-image'>
                                    <img src={post?.featuredImage.url} />
                                </div>}
                                <div className='blog--bloglist-post-content'>
                                    <h3 className='blog--bloglist-post-title'>{post?.title}</h3>
                                    <p className='blog--bloglist-post-description'>
                                        {post?.description}
                                    </p>
                                    <p className='blog--bloglist-post-link'>
                                        <span>Read More</span> <img className='read-arrow' src='/assets/icons/arrow-right.svg' />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>

            {/*
			<a className="blog--bloglist-more-post" href="/blog">
          		SEE MORE BLOG POSTS
			</a>
			*/}
        </div>

        <style jsx>
            {`
                .blog--bloglist {
                    padding: 100px 40px 108px;
                    margin: 0 auto;
                    background: #f9f9f9;

                    .blog--bloglist-wrapper {
                        .blog--bloglist-title {
                            font-weight: 800;
                            font-size: 42px;
                            line-height: 48px;
                            text-align: center;
                            color: #121651;
                            margin: 0;
                        }

                        .blog--bloglist-posts-section {
                            margin: 47px 0 0;

                            .blog--bloglist-post {
                                margin: 0 0 76px;
                                cursor: pointer;
                                position: relative;
                                z-index: 0;

                                .blog--bloglist-post-wrapper {
                                    max-width: 1357px;
                                    display: flex;
                                    width: 100%;
                                    margin: 0 auto;
                                    align-items: center;
                                    padding: 30px;
                                    border-radius: 10px;
                                    background: #F3F3F3;
                                    background-clip: padding-box;
                                    position: relative;
                                    border: solid 4px transparent;

                                    &:before {
                                        content: '';
                                        position: absolute;
                                        top: 0;
                                        right: 0;
                                        bottom: 0;
                                        left: 0;
                                        z-index: -1;
                                        margin: -4px;
                                        border-radius: inherit;
                                    }

                                    .blog--bloglist-post-image {
                                        flex: 1;
                                        margin: 0 18px 0 0;

                                        img {
                                            width: 100%;
                                            height: auto;
                                            z-index: 1000;
                                        }
                                    }

                                    .blog--bloglist-post-content {
                                        flex: 1;
                                        margin: 0 0 0 18px;

                                        .blog--bloglist-post-title {
                                            font-weight: 800;
                                            font-size: 32px;
                                            line-height: 39px;
                                            color: #121651;
                                            margin: 0;
                                        }

                                        .blog--bloglist-post-description {
                                            font-weight: 500;
                                            font-size: 18px;
                                            line-height: 25px;
                                            color: #4F4F4F;
                                            margin: 18px 0 0;
                                        }

                                        .blog--bloglist-post-link {
                                            display: flex;
                                            margin: 40px 0 0;
                                            align-items: flex-start;

                                            &:hover {
                                                img {
                                                    margin-left: 18px;
                                                }
                                            }

                                            span {
                                                font-weight: 800;
                                                font-size: 24px;
                                                line-height: 24px;
                                                background: -webkit-linear-gradient(135deg,
                                                #e637a8 2.69%,
                                                #e68137 75%);
                                                -webkit-background-clip: text;
                                                -webkit-text-fill-color: transparent;
                                                text-decoration-line: underline;
                                                border-bottom: 2px solid #e68137;
                                            }

                                            img {
                                                width: 35px;
                                                height: auto;
                                                margin-left: 6px;
                                                transition: margin-left 150ms ease;
                                            }
                                        }
                                    }
                                }

                                &:hover {
                                    .blog--bloglist-post-wrapper {
                                        //background-color: #E3E3E3;
                                        background-color: #ffffff;
                                        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
                                    }
                                }

                                &:active {
                                    .blog--bloglist-post-wrapper {
                                        background-color: #e3e3e3;
                                        box-shadow: none;
                                    }
                                }

                                &.reverse-order {
                                    .blog--bloglist-post-wrapper {
                                        flex-direction: row-reverse;

                                        .blog--bloglist-post-image {
                                            margin: 0 0 0 18px;
                                        }

                                        .blog--bloglist-post-content {
                                            margin: 0 18px 0 0;
                                        }
                                    }
                                }

                                &:nth-child(odd) {
                                    .blog--bloglist-post-wrapper {
                                        &:before {
                                            background: linear-gradient(135deg, #E637A8 2.69%, #E68137 75%);
                                        }
                                    }
                                }

                                &:nth-child(even) {
                                    .blog--bloglist-post-wrapper {
                                        &:before {
                                            background: linear-gradient(180deg, #1CC8E1 0%, #1C9AE1 100%);
                                        }
                                    }
                                }
                            }
                        }

                        .blog--bloglist-more-post {
                            font-weight: 800;
                            font-size: 32px;
                            line-height: 32px;
                            text-align: center;
                            background: -webkit-linear-gradient(135deg,
                            #e637a8 2.69%,
                            #e68137 75%);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                            border-bottom: 2px solid #e68137;
                            display: block;
                            width: fit-content;
                            margin: 104px auto 0;
                        }
                    }

                    @media (max-width: 768px) {
                        .blog--bloglist-wrapper {
                            .blog--bloglist-posts-section {
                                .blog--bloglist-post {
                                    margin: 60px 0 80px;
                                    background: #f3f3f3;
                                    border-radius: 5px;

                                    .blog--bloglist-post-wrapper {
                                        flex-direction: column;
                                        padding: 0;

                                        .blog--bloglist-post-image {
                                            margin: 0;
                                        }

                                        .blog--bloglist-post-content {
                                            margin: 0;
                                            padding: 20px 30px 30px;

                                            .blog--bloglist-post-title {
                                                font-size: 26px;
                                                line-height: 32px;
                                            }

                                            .blog--bloglist-post-description {
                                                font-size: 16px;
                                            }

                                            .blog--bloglist-post-link {
                                                font-size: 20px;
                                                margin-top: 20px;

                                                img {
                                                    width: 30px;
                                                    margin-top: 3px;
                                                }
                                            }
                                        }
                                    }

                                    &.reverse-order {
                                        .blog--bloglist-post-wrapper {
                                            flex-direction: column;

                                            .blog--bloglist-post-image {
                                                margin: 0;
                                            }

                                            .blog--bloglist-post-content {
                                                margin: 0;
                                            }
                                        }
                                    }
                                }
                            }

                            .blog--bloglist-more-post {
                                font-size: 26px;
                                margin-top: 50px;
                            }
                        }
                    }

                    @media (max-width: 480px) {
                        padding: 70px 20px 50px;

                        .blog--bloglist-wrapper {
                            .blog--bloglist-posts-section {
                                .blog--bloglist-post {
                                    .blog--bloglist-post-wrapper {
                                        .blog--bloglist-post-content {
                                            padding: 15px 20px 20px;
                                        }
                                    }
                                }
                            }

                            .blog--bloglist-more-post {
                                background: none;
                                border: none;
                                -webkit-text-fill-color: #e637a8;
                            }
                        }
                    }
                }
            `}
        </style>
    </div>
);
